var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileRecruitCubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mobile_recruit_cube_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.746,
    height: 18.975,
    viewBox: "0 0 16.746 18.975",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184027",
    "data-name": "\\uADF8\\uB8F9 184027",
    transform: "translate(0.261 4.219)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131800",
    "data-name": "\\uD328\\uC2A4 131800",
    d: "M408.588,217.965l8.2,4.567v-9.625l-8.2-4.567Z",
    transform: "translate(-408.341 -208.092)",
    fill: "#00ddb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131801",
    "data-name": "\\uD328\\uC2A4 131801",
    d: "M416.554,212.338l-8.2-4.567a.248.248,0,0,0-.368.217v9.625a.249.249,0,0,0,.127.217l8.2,4.567a.24.24,0,0,0,.121.031.248.248,0,0,0,.248-.248v-9.625A.248.248,0,0,0,416.554,212.338Zm-.368,9.421-7.7-4.291V208.41l7.7,4.291Z",
    transform: "translate(-407.989 -207.74)",
    fill: "#111"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184028",
    "data-name": "\\uADF8\\uB8F9 184028"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131802",
    "data-name": "\\uD328\\uC2A4 131802",
    d: "M408.588,202.411l8.246,4.575,7.482-4.194-8.245-4.575Z",
    transform: "translate(-408.08 -197.934)",
    fill: "#ffa8d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131803",
    "data-name": "\\uD328\\uC2A4 131803",
    d: "M407.357,202.01l8.754,4.858,7.992-4.479-8.754-4.858Zm15.728.381L416.11,206.3l-7.736-4.292,6.975-3.91Z",
    transform: "translate(-407.357 -197.531)",
    fill: "#32303c"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184029",
    "data-name": "\\uADF8\\uB8F9 184029",
    transform: "translate(8.61 4.611)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131804",
    "data-name": "\\uD328\\uC2A4 131804",
    d: "M428.8,223.157l7.378-3.936v-9.932l-7.378,4.146Z",
    transform: "translate(-428.547 -209.042)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131805",
    "data-name": "\\uD328\\uC2A4 131805",
    d: "M435.7,208.722l-7.379,4.146a.249.249,0,0,0-.126.216v9.723a.247.247,0,0,0,.365.218l7.379-3.937a.248.248,0,0,0,.131-.219v-9.931a.248.248,0,0,0-.369-.217Zm-.127,10-6.883,3.673v-9.164l6.883-3.867Z",
    transform: "translate(-428.194 -208.69)",
    fill: "#111"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileRecruitCubeIcon);
export default __webpack_public_path__ + "static/media/mobile_recruit_cube_icon.4492464399c4a19211c38041ea143a3a.svg";
export { ForwardRef as ReactComponent };